import React from 'react';
import { compose } from 'ramda';
import styleFile from './header.js';
import { RichText } from '@synergycms_core/components/generic';
import { withThemeJSS } from '@synergycms_core/components/providers/themeProvider';
import { iconsByTheme } from '@synergycms_core/components/functional/Engine/engineUtils';

const PromoCode = compose(withThemeJSS({ styleFile, displayName: 'Header' }))(props => {
  const { classes } = props.theme.styles;
  return (
    <div className={[classes.roomContainer, classes.promoCodeContainer].join(' ')}>
      <RichText
        icon={{ unicodeContent: iconsByTheme('boxPromoCode',props.theme.theme), innerStyle: ['size23'] }}
        innerStyle={classes.headerTitle}
      />
    </div>
  )
});

export default PromoCode;